import { useTranslation } from 'react-i18next';

import {
  CLASS_PLANNING_STATUS_LABEL_KEY,
  CLASS_PLANNING_STATUS_PILL_CLASSES,
  CLASS_PLANNING_STATUS_VALUES,
} from '../../../utils/classPlanningStatus';

/**
 * Legenda estática de status do planejamento de aula (Planejada/Finalizada/
 * Cancelada/Confirmada), sem interação — explica a cor de cada bolinha usada na
 * coluna Status da tabela. Usa classes de cor diretas (não a `Tag` do ADS), pois
 * a paleta do legado (laranja/preto/cinza claro/verde sólidos) inclui um "preto
 * sólido" que não existe no enum de `status` da `Tag`.
 */
export function ClassPlanningStatusLegend() {
  const { t } = useTranslation('classPlanning');

  return (
    <div className="flex flex-wrap items-center gap-xs">
      <span className="ts-paragraph-xxs text-ctx-content-base">{t('status.legendTitle')}</span>
      {CLASS_PLANNING_STATUS_VALUES.map(status => (
        <span
          key={status}
          className={`rounded-pill px-xxs py-quark ts-caption-xxs text-nowrap ${CLASS_PLANNING_STATUS_PILL_CLASSES[status]}`}
        >
          {t(CLASS_PLANNING_STATUS_LABEL_KEY[status] as 'status.planned')}
        </span>
      ))}
    </div>
  );
}
